<template>
  <div class="panel text-left">
    <div class="panel__header">
      <h3 class="panel__title">Product Type Commissions</h3>
    </div>

    <div class="panel__content">
      <p>Setting a commission rate on a product type will override global
        commission rates and
        vendor specific commission rates.</p>
    </div>

    <div :class="['loading-area', loading ? 'loading' : '']">
      <div :class="['loading-area__content', loading ? 'loading' : '']">
        <pagination :prev="prev" :next="next" :start="start" :end="end"
                    :total="total"
                    @paginate="paginate"></pagination>

        <div class="no-padding">
          <tableList classes="no-hover" :header="tableHeader" :data="tableData"
                     :loading="loading" @sort="orderBy"
                     @callback="callback"></tableList>
        </div>

        <pagination :prev="prev" :next="next" :start="start" :end="end"
                    :total="total"
                    @paginate="paginate"></pagination>
      </div>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="editingCommission">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Set Commission</h3>

              <span class="overlay__close" @click="closeCommission">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <input id="product-type-id" name="id" type="hidden">

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="product-type-commission">Set
                        Commission</label>
                    </div>

                    <div class="cell auto">
                      <input id="product-type-commission" class="short-input"
                             name="commission" type="text"
                             :value="editingCommissionValue">
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeCommission">Cancel
              </button>

              <button @click="saveCommission()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

export default {
  name: 'productTypes',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/products/types/',
      tableHeader: {
        data: [
          {
            label: 'Product Type',
            class: 'full'
          },
          {
            label: 'Commission Rate',
            class: 'large'
          },
          {
            label: 'Percentage'
          }
        ]
      },
      tableData: [],
      productTypeCommissions: [],
      editingCommission: false,
      editingCommissionId: null,
      editingCommissionValue: null,
      editingCommissionType: null,
      editingCommissionPercentage: null
    }
  },
  methods: {
    editCommission (id, value, type, commissionPercentage) {
      this.editingCommissionId = id
      this.editingCommission = true
      this.editingCommissionType = type
      this.editingCommissionPercentage = commissionPercentage

      if (value === 'default') {
        value = ''
      }

      this.editingCommissionValue = value
    },
    closeCommission () {
      this.editingCommission = false
    },
    saveCommission () {
      let value = document.getElementById('product-type-commission').value

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id === this.editingCommissionId) {
          this.data[i].commission.commission_rate = value
        }
      }

      let method = 'post'
      let url = '/vendors/product-type-commissions/'

      if (this.editingCommissionId !== null) {
        method = 'put'
        url = '/vendors/product-type-commission/' + this.editingCommissionId + '/'
      }

      let commissionPercentage = false

      if (this.editingCommissionPercentage !== null) {
        commissionPercentage = this.editingCommissionPercentage
      }

      if (value.length === 0) {
        value = null
      }

      if (this.editingCommissionId !== undefined) {
        this.request(method, url, {
          product_type: this.editingCommissionType,
          commission_rate: value,
          commission_percentage: commissionPercentage
        }).then((response) => {
          this.editingCommission = false

          this.getData()
        })
      }
    },
    buildTable () {
      let newData = []

      for (let i = 0; i < this.data.length; i++) {
        let commissionId = null
        let commissionRate = 'default'
        let commissionPercentage = null

        if (this.data[i].commission !== null) {
          commissionId = this.data[i].commission.id

          if (this.data[i].commission.commission_rate !== null) {
            commissionRate = this.data[i].commission.commission_rate.toFixed(2)
          }
          commissionPercentage = this.data[i].commission.commission_percentage
        }

        newData.push({
          post: this.data[i].id,
          data: [
            {
              value: this.data[i].product_type,
              class: 'full focus-text'
            },
            {
              value: commissionRate,
              class: 'large',
              edit: true,
              callback: 'editCommission',
              callbackArgs: [commissionId, commissionRate, this.data[i].product_type, commissionPercentage]
            },
            {
              type: 'checkbox',
              value: commissionPercentage,
              callback: 'saveProductType',
              callbackArgs: [commissionId, commissionRate, this.data[i].product_type, commissionPercentage]
            }
          ]
        })
      }

      this.tableData = newData
    },
    saveProductType (id, commissionRate, productType, percentage) {
      if (commissionRate === 'default') commissionRate = null

      let commissionPercentage = false

      if (percentage !== null) {
        commissionPercentage = !percentage
      }

      if (id) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].id === id) {
            this.data[i].commission.commission_percentage = !percentage
          }
        }

        this.request('put', '/vendors/product-type-commission/' + id + '/', {
          commission_percentage: commissionPercentage,
          commission_rate: commissionRate,
          product_type: productType
        }).then((response) => {
          this.getData()
        })
      } else {
        this.request('post', '/vendors/product-type-commissions/', {
          product_type: productType,
          commission_rate: commissionRate,
          commission_percentage: commissionPercentage
        }).then((response) => {
          this.getData()
        })
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/settings/productTypes.vue